module.exports = __webpack_public_path__ + "static/media/star.89283e2f.jpg";